import { clickedOnLoggedOutPage } from '@bridebook/web/app-basic/lib/analytics/tracking-actions/logged-out-page-click';
import {
  getSupplier,
  getSupplierFeedbackCount,
  getSupplierLoaded,
  getSupplierReviews,
} from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { noop } from 'remeda';
import SupplierInfoComp from '@bridebook/web/app-basic/components/supplier/sections/supplier-info/supplier-info';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { IBreadcrumbItem } from '@bridebook/web/app-shared/lib/types';
import { UrlHelper } from '@bridebook/web/lib/url-helper';

interface IProps {
  breadcrumbsData?: IBreadcrumbItem[];
  isVenueProfileV2?: boolean;
}

const SupplierInfo = ({ breadcrumbsData, isVenueProfileV2 }: IProps) => {
  const supplier = useSelector(getSupplier);
  const reviews = useSelector(getSupplierReviews);
  const isSupplierLoaded = useSelector(getSupplierLoaded);
  const feedbackCount = useSelector(getSupplierFeedbackCount);
  const dispatch = useDispatch();
  const router = useRouter();
  const market = useMarket();

  const locationPinInfo = breadcrumbsData?.filter(
    (item) => item.id === 'county' || item.id === 'town',
  );
  const mainCategoryInfo = breadcrumbsData?.find(
    (breadcrumb) => breadcrumb.id === 'supplier-category',
  );
  if (mainCategoryInfo?.path && !market.flags.monetized) {
    locationPinInfo?.push({
      id: 'country-name',
      name: market.getCountryName(),
      path: mainCategoryInfo.path,
    });
  }

  const onTestimonialsClick = useCallback(() => {
    if (!supplier) return;

    dispatch(
      clickedOnLoggedOutPage({
        clickedSection: 'title',
        cta: 'reviewAndTestimonials',
        supplierId: supplier.id,
        clickedLocation: 'supplierProfile',
      }),
    );
    router.push(UrlHelper.signup);
  }, [dispatch, router, supplier]);

  if (!supplier) return null;

  const props = {
    feedbackCount,
    isSupplierLoaded,
    onLocationClick: noop,
    onTestimonialsClick: supplier.type[0] === 'venue' ? onTestimonialsClick : undefined,
    reviews,
    supplier,
    locationPinInfo,
  };

  return <SupplierInfoComp {...props} isVenueProfileV2={isVenueProfileV2} />;
};

export default SupplierInfo;
